/* eslint-disable react/prop-types */
import React, { useCallback, useRef, useState } from "react";
import { ThemeCustomInputField } from "../../../../shared/themeComponents/themeCustomInputField";
import { Button, Checkbox, FormControl, IconButton, InputAdornment, Tooltip } from "@material-ui/core";
import { LoginDetailsSignUpProps } from "../../../../../@types/components/signupV2.types";

// logos and images
import AccountCircle from "@material-ui/icons/AccountCircle";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import "./loginDetails.scss";

const LoginDetails = ({
	handleSubmit,
	user,
	validation,
	handleChange,
	hasReadStatementOfUnderstanding,
	handleStatementOfUnderstandingRead,
	handleStatementOfUnderstandingOpen,
	confirmPassword,
	confirmPasswordValidation,
	handleConfirmPasswordChange,
	checkInvalidUserName,
	userNameExists,
	handleBack
}: LoginDetailsSignUpProps) => {
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setConfirmShowPassword] = useState(false);

	const handleShowPassword = useCallback(() => {
		setShowPassword(!showPassword);
	}, [showPassword]);

	const handleShowConfirmPassword = useCallback(() => {
		setConfirmShowPassword(!showConfirmPassword);
	}, [showConfirmPassword]);

	const ref = useRef(null);

	return (
		<div className="login-details-main-container">
			<form onSubmit={handleSubmit} autoComplete="off" method="">
				<FormControl className="form-container" id="form-container">
					{/* EMAIL AND USERNAME INPUT */}
					<span className="form-field-labels">Username</span>
					<ThemeCustomInputField
						className="form-field-input"
						style={{ width: 400, borderRadius: 5 }}
						placeholder="Enter your username"
						name="user_name"
						variant="outlined"
						value={user.user_name}
						onChange={handleChange}
						helperText={
							userNameExists
								? "Username exists!"
								: checkInvalidUserName
								? "Username must be 4-20 characters, alpha-numeric, no special characters"
								: validation.user_name
						}
						InputProps={{
							endAdornment: (
								<InputAdornment position="start">
									<AccountCircle style={{ color: "#a06cd5" }} />
								</InputAdornment>
							)
						}}
					/>
					{/* PASSWORD INPUT */}
					<span className="form-field-labels">Password</span>
					<ThemeCustomInputField
						className="form-field-input"
						type={!showPassword ? "password" : "text"}
						style={{ width: 400, borderRadius: 5 }}
						name="password"
						placeholder="Enter your password"
						variant="outlined"
						value={user.password}
						onChange={handleChange}
						helperText={validation.password ? validation.password : null}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									{!showPassword ? (
										<IconButton onClick={handleShowPassword}>
											<VisibilityOffIcon style={{ color: "#a06cd5" }} />
										</IconButton>
									) : (
										<IconButton onClick={handleShowPassword}>
											<VisibilityIcon style={{ color: "#a06cd5" }} />
										</IconButton>
									)}
								</InputAdornment>
							)
						}}
					/>
					{/* CONFIRM PASSWORD INPUT */}
					<span className="form-field-labels">Confirm Password</span>
					<ThemeCustomInputField
						className="form-field-input"
						type={!showConfirmPassword ? "password" : "text"}
						style={{ width: 400, borderRadius: 5 }}
						name="confirmPassword"
						placeholder="Confirm your password"
						variant="outlined"
						value={confirmPassword}
						onChange={handleConfirmPasswordChange}
						helperText={confirmPasswordValidation ? confirmPasswordValidation : null}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									{!showConfirmPassword ? (
										<IconButton onClick={handleShowConfirmPassword}>
											<VisibilityOffIcon style={{ color: "#a06cd5" }} />
										</IconButton>
									) : (
										<IconButton onClick={handleShowConfirmPassword}>
											<VisibilityIcon style={{ color: "#a06cd5" }} />
										</IconButton>
									)}
								</InputAdornment>
							)
						}}
					/>
					{/* CHECKBOX : I HAVE AGREED THE STATEMENT OF UNDERSTANDING */}
					<div className="sou-checkbox" id="sou-checkbox">
						<Checkbox
							name="hasReadStatementOfUnderstanding"
							style={{
								color: "#9c27b0"
							}}
							value={hasReadStatementOfUnderstanding}
							onChange={handleStatementOfUnderstandingRead}
						/>
						<span>I have read the </span>
						<span className="sou" onClick={handleStatementOfUnderstandingOpen}>
							Statement of Understanding
						</span>
					</div>
				</FormControl>
			</form>
		</div>
	);
};

export default LoginDetails;
